<template>
<div class="form-password" :data-layout="layout">
  <div class="form-password__body">
    <formLabel :label="label" :validation="validation"></formLabel>
    <!-- <div class="Password__toggle" @click="togglePassword" :class="{is_text: type === 'text'}">
      <span v-show="type === 'password'">パスワードを表示</span>
      <span v-show="type === 'text'">パスワードを非表示</span>
    </div> -->
    <div class="form-password__input">
      <input
        class="form-password__password"
        :type="type"
        ref="input"
        v-validate="validation"
        :data-error="errors.has(name)"
        @input="update($event)"
        :name="name"
        :value="value"
        :placeholder="placeholder"
      >
      <div :class="['form-password__icon', {'form-password__icon--thin': !value}]" @click="togglePassword">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9993 4.125C6.41602 4.125 2.50185 6.97583 0.916016 11C2.50185 15.0242 6.41602 17.875 10.9993 17.875C15.5827 17.875 19.4969 15.0242 21.0827 11C19.4969 6.97583 15.5827 4.125 10.9993 4.125ZM10.9993 15.5833C8.46935 15.5833 6.41602 13.53 6.41602 11C6.41602 8.47 8.46935 6.41667 10.9993 6.41667C13.5294 6.41667 15.5827 8.47 15.5827 11C15.5827 13.53 13.5294 15.5833 10.9993 15.5833ZM10.9993 8.25C9.47768 8.25 8.24935 9.47833 8.24935 11C8.24935 12.5217 9.47768 13.75 10.9993 13.75C12.521 13.75 13.7493 12.5217 13.7493 11C13.7493 9.47833 12.521 8.25 10.9993 8.25Z" fill="#FF7497"/>
          <rect v-show="type === 'password'" x="17.9248" y="2.86816" width="1" height="22" transform="rotate(45 17.9248 2.86816)" fill="#FF7497"/>
        </svg>
      </div>
    </div>

  </div>
  <div class="form-password__footer">
    <div :class="[strengthMeterClass]" v-if="strengthMeter">
      <div :class="[strengthMeterFillClass]" :data-score="passwordStrength"></div>
    </div>
    <slot></slot>
    <p v-if="password1" class="form-password__error-message">{{ password1 }}</p>
  </div>
</div>
</template>

<script>
import PasswordChecker from "./PasswordChecker";
import mixin from "./mixin";

export default {
  mixins: [mixin],
  props: {
    secureLength: {
      type: Number,
      default: 7
    },
    strengthMeter: {
      type: Boolean,
      default: true
    },
    strengthMeterClass: {
      type: String,
      default: "password-strength-meter"
    },
    strengthMeterFillClass: {
      type: String,
      default: "password-strength-meter--fill"
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      password: null,
      checker: new PasswordChecker(),
      type: "password"
    };
  },
  methods: {
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
    }
  },
  computed: {
    /**
     * passwordStrength is the score calculated
     * @return {Number} Password Strength Score
     */
    passwordStrength() {
      this.checker.input = String(this.modelValue)
      return this.checker.getStrength()
    },
    password1() {
      for(var i = 0;i < this.errors.items.length; i++) {
        if (this.errors.items[i].field == this.name) {
          switch (this.errors.items[i].rule) {
            case ('max') :
              return this.errors.items[i].msg = '8～30文字で入力してください。'
              break;
            case ('min') :
              return this.errors.items[i].msg = '8～30文字で入力してください。'
              break;
            case ('required') :
              return this.errors.items[i].msg = 'パスワードを入力してください。'
              break;
            default:
              return this.errors.items[i].msg
              break;
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped >
@import "../../../../sass/commons/commonVariables.scss";

.form-password{
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.4;
  color: $col_base_black;
  &__input{
    position: relative;
  }
  &__password {
    appearance: none;
    display: block;
    width: 100%;
    padding: 9.5px 38px 9.5px 12px;
    border: 1px solid $col_temp_gray3;
    background: none;
    border-radius: 5px;
    line-height: inherit;
    outline: none;
    &::placeholder {
      color: #AAB2BD;
    }
    &--error {
      border-color: rgba($col_temp_key1, 0.6);
      background: rgba($col_temp_pink, 0.6);
    }
  }
  &__icon{
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 22px;
    &--thin {
      opacity: 0.4;
    }
  }
  &__error-message {
    font-weight: bold;
    color: $col_temp_key1;
    font-size: 13px;
    margin-top: 6px;
    text-shadow: 0 0 5px #ffffff;
  }
}

.password-strength-meter {
  position: relative;
  height: 6px;
  background: #dddddd;
  margin: 2px auto;
  &::before,
  &::after {
    content: "";
    height: inherit;
    background: transparent;
    display: block;
    border-color: #fff;
    border-style: solid;
    border-width: 0 4px 0 4px;
    position: absolute;
    width: 20%;
    width: calc(20% + 2px);
    z-index: 2;
  }
  &::before {
    left: 20%;
  }
  &::after {
    right: 20%;
  }
  &--fill {
    background: transparent;
    height: inherit;
    position: absolute;
    width: 100%;
    transform: scale(0, 1);
    transform-origin: left;
    border-radius: inherit;
    transition: transform 0.5s ease-in-out, background 0.25s;
    &[data-score="0"] {
      background: darkred;
      transform: scale(0, 1);
    }
    &[data-score="1"] {
      background: darkred;
      transform: scale(0.2, 1);
    }
    &[data-score="2"] {
      background: orangered;
      transform: scale(0.4, 1);
    }
    &[data-score="3"] {
      background: orange;
      transform: scale(0.6, 1);
    }
    &[data-score="4"] {
      background: yellowgreen;
      transform: scale(0.8, 1);
    }
    &[data-score="5"] {
      background: green;
      transform: scale(1, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormPassword.vue